import {Component, Renderer2} from '@angular/core';
import {
  ApplicationAlertService,
  AppRoot,
  LocalLanguageService,
  PersistenceService,
  SettingsService,
  UiUpdateService,
  ValidationChangeService,
  ModelChangeService,
  LogManager,
} from '@visana-web/basic-ui';
import {ActivatedRoute, Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {HttpErrorResponse, HttpResponse} from '@angular/common/http';
import {ClientModel} from 'app/model/client-model';
import {NavigationEnd} from '@angular/router';
import {GoogleTagManagerService} from 'angular-google-tag-manager';
import {Meta, Title} from '@angular/platform-browser';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent extends AppRoot {

  spinner = false;

  clientModel = new ClientModel();

  constructor(protected translateService: TranslateService,
              protected localLanguageService: LocalLanguageService,
              protected route: ActivatedRoute,
              protected router: Router,
              protected applicationAlertService: ApplicationAlertService,
              protected validationChangeService: ValidationChangeService,
              protected uiUpdateService: UiUpdateService,
              protected persistenceService: PersistenceService,
              protected settingsService: SettingsService,
              protected renderer: Renderer2,
              private modelChangeService: ModelChangeService<ClientModel>,
              protected logManager: LogManager,
              protected titleService: Title,
              protected metaTagService: Meta,
              private gtmService: GoogleTagManagerService
  ) {
    super(translateService,
      localLanguageService,
      route,
      router,
      applicationAlertService,
      validationChangeService,
      uiUpdateService,
      persistenceService,
      settingsService,
      logManager,
      titleService,
      metaTagService,
      renderer);
    this.currentAppName = 'Visana';
    this.currentPageMetaTitle = 'pkb.imprestAccount.app-title';
    this.currentPageMetaDescription = 'pkb.imprestAccount.search-title';
    this.handledQueryParams = ['_ga', 'reset'];
    this.modelChangeService.updateModel(this.clientModel);
    this.modelChangeService.observableModel.subscribe(value => {
      this.clientModel = value;
    });
    this.router.events.subscribe(value => {
      if (value instanceof NavigationEnd) {
        const gtmTag = {
          event: 'page',
          pageName: value.url,
        };
        this.gtmService.pushTag(gtmTag);
      }
    });
  }

  openWindow(id: string) {
    const link = this.translateService.instant(id);
    window.open(link, id);
  }

  // kleiner Test:        <div><button (click)="reloadPage()">Reset</button></div>
  //public reloadPage(){
  //  window.location.reload();
  //}

  public handleHttpResponse(resp: HttpErrorResponse | HttpResponse<any>): boolean {
    if (super.handleHttpResponse(resp)) {
      return true;
    }
    // suppress entity too large error message toaster for typeahead component
    if ((resp.status === 413) && (resp.url.indexOf('cityMappings') > -1)) {
      return true;
    }

    if ((resp.status === 413) && (resp.url.indexOf('gatekeepers/search') > -1)) {
      return true;
    }
    return false;
  }
}
